// A JWT's payload is base64URL ("-" and "_", no padding), not plain base64. atob() throws
// on "-" / "_", and that throw used to read as "expired" — a logout for a token that was
// fine (QA DEF-19). Decode base64url first.
export const decodeJwtPayload = (token) => {
  const part = String(token || "").split(".")[1];
  if (!part) throw new Error("no payload");
  const b64 = part.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(part.length / 4) * 4, "=");
  return JSON.parse(atob(b64));
};

export const isTokenExpired1 = (token) => {
  if (!token) return true;

  const payload = decodeJwtPayload(token);
  return payload.exp * 1000 < Date.now();
};

export const isTokenExpired = (token) => {
  // console.warn("Expiration Check!!!");

  if (!token) return true;

  try {
    const payload = decodeJwtPayload(token);

    return payload.exp * 1000 < Date.now();
  } catch (error) {
    console.error("Invalid token format", error);
    return true;
  }
};

// QA DEF-19: only OUR API saying the session is over logs the user out — a 401 whose
// body carries the server's `token: "expired"` marker (middleware/checkToken). Any 401
// used to log out: a third-party call, a permission refusal, or a database hiccup that
// the server reported as 401. Reads a CLONE so the caller still gets the body.
export const isSessionExpiredResponse = async (response) => {
  if (!response || response.status !== 401) return false;
  try {
    const body = await response.clone().json();
    return !!body && body.token === "expired";
  } catch (e) {
    return false;
  }
};

// The owner portal refused a request on ACCESS grounds — the person's role does not
// hold the feature, or holds it at View only (controller/saas/_featureGate). Never a
// logout: the owner may just have changed their role, so the portal re-reads it.
export const ACCESS_REFUSAL_CODES = ["FEATURE_READ_ONLY", "FEATURE_NOT_GRANTED"];
export const isAccessRefusalResponse = async (response) => {
  if (!response || response.status !== 403) return false;
  try {
    const body = await response.clone().json();
    return !!body && ACCESS_REFUSAL_CODES.includes(body.code);
  } catch (e) {
    return false;
  }
};

// A WTF Go support session ended (middleware/supportAuth). Never a logout: in a support
// tab it shows the "ended" screen, and anywhere else — e.g. the /support/enter hand-off,
// which still shares the admin's storage — logging out would sign the ADMIN out.
export const isSupportEndedResponse = async (response) => {
  if (!response || response.status !== 401) return false;
  try {
    const body = await response.clone().json();
    return !!body && body.code === "SUPPORT_SESSION_ENDED";
  } catch (e) {
    return false;
  }
};
